if (!customElements.get('specie-item')) {
  customElements.define(
    'specie-item',
    class SpecieItem extends HTMLElement {
      constructor() {
          super();
          this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
          event.stopPropagation();

          if (!this.hasAttribute('data-server-cultivars')) return;

          const wrapper = this.closest('.specie-item-with-cultivars');
          if (!wrapper) return;

          event.preventDefault();

          const cultivarsContainer = wrapper.querySelector('.specie-cultivars');
          if (!cultivarsContainer) return;

          const willOpen = !cultivarsContainer.classList.contains('active');

          // Close sibling open cultivar sections
          const parentEl = wrapper.parentElement;
          if (parentEl) {
              parentEl.querySelectorAll('.specie-cultivars.active').forEach(el => {
                  if (el !== cultivarsContainer) el.classList.remove('active');
              });
              parentEl.querySelectorAll('.specie-item.active').forEach(el => {
                  if (el !== this) el.classList.remove('active');
              });
          }

          cultivarsContainer.classList.toggle('active', willOpen);
          this.classList.toggle('active', willOpen);
      }
    }
  );
}